// extracted by css-extract-rspack-plugin
export default {"limitHeight":"ReviewThread-module__limitHeight__PbyWB"};